/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { ActiveDirectorySettings } from '@modules/cloud-api/v1/types'
import withRouter from '@modules/routing/withRouter'

import {
  updateActiveDirectorySecurityRealmRequest,
  fetchActiveDirectorySecurityRealmRequest,
} from '@/apps/adminconsole/reducers/registry'
import { getActiveDirectoryAuthProvider } from '@/apps/adminconsole/reducers/activeDirectoryAuthProviders'

import {
  fetchActiveDirectorySecurityRealm,
  fetchSecurityCluster,
  updateActiveDirectorySecurityRealm,
} from '../../../../../actions'

import EditActiveDirectoryProvider from './EditActiveDirectoryProvider'

const mapStateToProps = (
  state,
  {
    router: {
      params: { regionId, realmId },
    },
  },
) => ({
  activeDirectorySettings: getActiveDirectoryAuthProvider(state, regionId, realmId),
  fetchActiveDirectorySecurityRealmRequest: fetchActiveDirectorySecurityRealmRequest(
    state,
    regionId,
    realmId,
  ),
  updateActiveDirectorySecurityRealmRequest: updateActiveDirectorySecurityRealmRequest(
    state,
    regionId,
    realmId,
  ),
  regionId,
  realmId,
})

const mapDispatchToProps = (
  dispatch,
  {
    router: {
      params: { regionId, realmId },
    },
  },
) => ({
  fetchActiveDirectorySecurityRealm: () =>
    dispatch(fetchActiveDirectorySecurityRealm(regionId, realmId)),
  onSubmit: (payload: ActiveDirectorySettings) =>
    dispatch(updateActiveDirectorySecurityRealm(regionId, realmId, payload)).then(() =>
      dispatch(fetchSecurityCluster(regionId)),
    ),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditActiveDirectoryProvider))
